import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AppRemixIcon } from '@/layout/AppComponents';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../helpers/Translator';

const SelectLanguageWithSortSystem = (props) => {
  const { value, error, onChange } = props;
  const [selectedLanguages, setSelectedLanguages] = useState(value);
  const languages = useSelector((state) => state.auth.languages);

  useEffect(() => {
    setSelectedLanguages(value);
  }, [value]);

  useEffect(() => {
    onChange(selectedLanguages);
  }, [selectedLanguages]);

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const onDragAndDrop = (reorderElements) => {
    setSelectedLanguages(
      reorder(
        selectedLanguages,
        reorderElements.source.index,
        reorderElements.destination.index
      )
    );
  };

  return (
    <>
      <div className="mt-4">
        <p>
          <b>Idiomas:</b>{' '}
          <Translator
            file="module-userManagement"
            name="module.um.reorder-according-preference"
          />
        </p>
        <DragDropContext onDragEnd={(r) => onDragAndDrop(r)}>
          <Droppable droppableId="droppable">
            {(providedDroppable) => (
              <ul
                className="list-group"
                {...providedDroppable.droppableProps}
                ref={providedDroppable.innerRef}
                style={{ height: `${selectedLanguages?.length * 41}px` }}
              >
                {selectedLanguages?.map((l, i) => {
                  const lang = languages?.find((lng) => lng.slug === l);
                  if (lang) {
                    return (
                      <Draggable key={lang.id} draggableId={l} index={i}>
                        {(providedDraggable) => (
                          <li
                            ref={providedDraggable.innerRef}
                            {...providedDraggable.draggableProps}
                            {...providedDraggable.dragHandleProps}
                            className="list-group-item p-2 pointer"
                          >
                            <AppRemixIcon
                              icon="arrow-up-down"
                              className="mr-2"
                            />
                            {`(${lang.slug}) ${lang.name}`}
                          </li>
                        )}
                      </Draggable>
                    );
                  }
                })}
              </ul>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </>
  );
};

export default SelectLanguageWithSortSystem;
